import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useTheme } from "styled-components/macro";

const SkeletonScreen = ({
  width = "100%",
  height,
  count = 1,
  baseColor = null,
  highlightColor = null,
  circle,
  ...restProps
}) => {
  const theme = useTheme();
  return (
    <Skeleton
      circle={circle}
      width={width}
      height={height}
      baseColor={baseColor || theme.surface}
      highlightColor={highlightColor || theme.surfaceSecondary}
      count={count}
      {...restProps}
    />
  );
};

export default SkeletonScreen;
